import { addCurso } from "data/apiConection.js/dataCursos"; // Actualiza con la ruta correcta
import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";

const FormCurso = ({ setFlagAddCurso, flagAddCurso }) => {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    curso: "",
    aula: "",
    nivel: "",
    horario: "",
    price: ""
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const body = {
        ...formData,
        price: parseFloat(formData.price) || 0 // Asegurar que el precio sea un número
      };
      console.log(body);
      const response = await addCurso(body);
      if (response.message === "Curso created successfully!") {
        setFlagAddCurso(!flagAddCurso);
      }
    }
    setValidated(true);
  };

  return (
    <Card className="p-4">
      <Card.Body>
        <Card.Title className="mb-4">Formulario de Registro de Curso</Card.Title>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="curso">
              <Form.Label>Curso</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nombre del Curso"
                value={formData.curso}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el nombre del curso.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="aula">
              <Form.Label>Aula</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Aula"
                value={formData.aula}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el aula.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="nivel">
              <Form.Label>Nivel</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nivel"
                value={formData.nivel}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el nivel.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="horario">
              <Form.Label>Horario</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Horario"
                value={formData.horario}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un horario válido.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="price">
              <Form.Label>Precio</Form.Label>
              <Form.Control
                required
                type="number"
                placeholder="Precio del curso"
                value={formData.price}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un precio válido.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="d-grid gap-2 mt-4">
            <Button type="submit" size="lg">
              Enviar Curso
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

FormCurso.propTypes = {
  setFlagAddCurso: PropTypes.func,
  flagAddCurso: PropTypes.bool
};

export default FormCurso;
